import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getTollfree } from "store/modules/phone";

export const useTollfreeNumber = (initialPhone = {}) => {
  const [phone, setPhone] = useState(initialPhone);
  const dispatch = useDispatch();

  const handleFetchNumber = useCallback(async (data) => {
    const {
      payload: { result }
    } = await dispatch(getTollfree(data));
    setPhone(result);
    return result;
  }, [dispatch]);

  return { phone, handleFetchNumber };
};

export default useTollfreeNumber;